module.exports = __webpack_public_path__ + "static/media/Laboratory.c95b8ed3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/ListBox/components/HitListModal/components/Table/Laboratory.svg
// module id = 150
// module chunks = 0